/*
 * fn: removeMediavineVariables
 *
 * Remove window variables set by MediaVine
 *
 */
export const removeMediavineVariables = () =>
  ['$adManagementConfig', '$mediavine', 'Fides'].forEach((key) => {
    try {
      if (key in window) delete window[key as any]
    } catch {
      // Ignore
    }
  })
